import { Route, Routes } from 'react-router-dom';

import List from './all/List';
import { Details } from './details/Details';
import { NewRequestPage } from './new-request';
import { AppRoutes } from 'config/routes';
import { NewContractPreview } from 'components/contracts/new-contract-preview/NewContractPreview';

function CustomWidget() {
  const { NewRequest, RequestApproval, Signature } = AppRoutes.Dashboard.CustomWidget;

  return (
    <Routes>
      <Route path="/" element={<List />} />
      <Route path="/:id/*" element={<Details />} />

      <Route path={NewRequest} element={<NewRequestPage />} />
      <Route path={RequestApproval + '/:id'} element={<NewRequestPage />} />

      <Route path={NewRequest + '/:id'} element={<NewRequestPage />} />
    </Routes>
  );
}

export default CustomWidget;
